import type { LocaleDictionary } from "@/i18n/types";

const nsAuthJA = {
  login: {
    button: "ログイン",
  },
  loginWaiting: {
    message: "ログイン中です...",
  },
  emailVerification: {
    instruction:
      "検証用のメールを送付しました。メールを確認し、再度ログインしてください。",
    resendSuccess: "検証メールを再送しました。検証後、再ログインしてください。",
    resendError: ({ detail }: { detail: string }) =>
      `検証メールの再送に失敗しました。${detail}`,
    resendButton: "再送する",
    reloginButton: "再ログイン",
    logoutButton: "ログアウト",
    dismissLabel: "閉じる",
  },
  initialSetting: {
    pageTitle: "初期設定",
    mfa: {
      question: "不正なログインを防ぐため2段階認証を設定しますか？",
      note: "スキップした場合もアカウント設定で登録できます",
      setupButton: "2段階認証を設定する",
      skipButton: "2段階認証をスキップしてログインする",
      inProgressTitle: "処理中です",
      errorMessage: "設定に失敗しました",
    },
    organization: {
      checkOrganizationsButton: "参加中、もしくは招待されている組織を確認する",
    },
  },
} satisfies LocaleDictionary;

export default nsAuthJA;
